// Brand faces. style.css has always asked for Jost (headings) and Open Sans
// (body), but the files were never shipped or linked, so the site quietly fell
// back to the system sans. Self-hosted rather than pulled from Google, so
// there's no third-party request.
//
// The static packages rather than the variable ones: those register the family
// as "Jost Variable", which wouldn't match the ~25 `font-family: 'Jost'` rules
// already in style.css. Only the weights the stylesheets actually use.
// Imported first, ahead of the stylesheets that reference them.
import "@fontsource/jost/400.css";
import "@fontsource/jost/500.css";
import "@fontsource/jost/600.css";
import "@fontsource/jost/700.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";

import "swiper/css";
// import "swiper/css/pagination";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "/public/css/custom.css";
import "/public/css/dark.css";
import "/public/css/plugins.css";
import "/public/css/style.css";

createApp(App).use(router).mount("#app");
